import { Typography, TypographyProps } from "@mui/material";

const T = (props: TypographyProps) => {
  return <Typography {...props} />;
};

export default T;
